import { ParamIds, Places } from 'src/Constants'
import BorderoKeys from '../bordero.keys'

export class ResultadoAnaliseKeys extends BorderoKeys {
    get place() {
        return Places.mcResultadoAnalise
    }

    get borderoId() {
        return this._intent.getParameterAsNumber(ParamIds.mcBorderoFormId)
    }

    set borderoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcBorderoFormId, value)
    }
}
